import { Component, Shark, Utils } from "shark-mvc";
import $ from "jquery";

import templateContent from "./multi-date-badge.html";

import { informationModalComponent } from "../informationModal/informationModalComponent";

class ConstructionSiteMultiDateComponent extends Component {
	constructor() {
		super("constructionSiteMultiDateComponent");

		this.addTemplate("badge", templateContent);
	}
	
	beforeUnload () {
		this.set("referenceListName", null);
	}

	init () {
		this.addComponents([informationModalComponent])
		this.set("referenceListName", null);
	}
	
	showExtraDatesBtn_clickHandler (event, data) {
		const referenceListName = this.get("referenceListName");
		
		if (referenceListName) {
			const currItem = Utils.safp(Shark.get(referenceListName), "guid", data.guid);
			
			if (currItem) {
				let extraDatesHTML = "";
				switch (currItem.__modelName) {
					case "NotComplianceReport":
						extraDatesHTML = currItem.ccaDetails.timeRanges.map(item => {
							return `${item.__constructionApplicatorTeam} dal <strong>${item.__dateStartLabel}</strong> al <strong>${item.__dateEndLabel}</strong>`;
						}).join("<br>");
						break;
						break;
					default:
						extraDatesHTML = currItem.__extraDates.map(item => {
							return `${item.constructionApplicatorTeam} dal <strong>${item.__timeSpanStartLabel}</strong> al <strong>${item.__timeSpanEndLabel}</strong>`;
						}).join("<br>");
						break;
				}
					
				informationModalComponent.show({
					body: "Questo Cantiere prevede più sessioni di lavoro in diverse date:<br><br>" + extraDatesHTML,
					title: "Date degli interventi"
				});
			}
		}
	}
}

const constructionSiteMultiDateComponent = new ConstructionSiteMultiDateComponent();

Shark.registerComponent(constructionSiteMultiDateComponent);

export { constructionSiteMultiDateComponent };
